/**
 * Yes, camel case of interface properties.
 * Thanks to developer who forgot to set serialization options on back-end!
 * ヽ(ｏ`皿′ｏ)ﾉ
 */
